
<div class="modal-dialog">
  <div class="modal-content" style="min-width:850px;">
    <div class="modal-header">
      <h5 class="modal-title">Choose Serial Number</h5>
      <button class="close" type="button" (click)="close()">&times;</button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col">
          <p><b>[{{ asset.readableType }}]</b> {{ asset.productDescription }}
             ({{ asset.productNumber }})<br>Device Key: {{ asset.deviceKey }}<br>Site: {{ asset.site }}<span *ngIf="asset.building"><br>Building: {{ asset.building }}</span><span *ngIf="asset.floor"><br>Floor: {{ asset.floor }}</span><span *ngIf="asset.mapId"><br>Map ID: {{ asset.mapId }}</span>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="filteredEligibleSandyItems.length" (onChange)="onListControlsChange($event)"></list-controls>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th>Serial Number</th>
                <th>Tracking Number</th>
                <th>Ship Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <ng-template ngFor let-item [ngForOf]="displayedEligibleSandyItems">
                <tr *ngIf="!item.selected || item.id === asset.sandyId" [ngClass]="{'table-success': item.selected}">
                  <td>{{ item.serialNumber }}</td>
                  <td>{{ item.trackingNumber }}</td>
                  <td>{{ item.shippingDate }}</td>
                  <td *ngIf="item.selected">
                    <button class="btn btn-outline-danger btn-sm" type="button" (click)="asset.clearSandyItem()">Clear</button>
                  </td>
                  <td *ngIf="!item.selected">
                    <button class="btn btn-outline-primary btn-sm" type="button" (click)="asset.assignSandyItem(item)">Select</button>
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" type="button" (click)="close()">Close</button>
    </div>
  </div>
</div>